import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import { getSiteSubDomain } from '../util/util';
import { AppConfig } from '../AppConfig';

class MaintenancePage extends React.Component {
  componentDidMount(): void {
    let slug = getSiteSubDomain();
    if(slug != 'www') {
      let item = window.localStorage.getItem('Community-' + slug);
      if(item) {
        let community = JSON.parse(item);
        AppConfig.setCommunity(community);
        this.forceUpdate();
      }
    }
  }
  
  render() {
    return (
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column" style={{alignItems: 'center'}}>
            <img 
              style={{
                width: '280px', 
                height: '195px', 
                borderRadius: '10px'
              }} 
              src="/maintenance.png" 
              alt="Maintenance"
            />
            <div style={{fontSize: '1.5em', marginTop: '10px'}}>
              <b>{AppConfig.title}</b>
            </div>
            <div style={{color: 'var(--body-text-color)'}}>We will be right back!</div>
          </div>
        </PageEnvelope>
      </div>
    )
  }
}

export default MaintenancePage;

